module.exports = __webpack_public_path__ + "img/thumbnail_Axolotl_u_albino.e360bb2b.png";